var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "profile-field__title",
          class: {
            "profile-field__title--required": _vm.field.required,
          },
        },
        [_vm._v(" " + _vm._s(_vm.field.name) + " ")]
      ),
      _vm.preview
        ? _c("div", { staticClass: "preview" }, [
            _c(
              "div",
              { staticClass: "file-preview" },
              [
                _c("file-preview", {
                  attrs: {
                    type: "doc",
                    name: "Документ 1.docx",
                    "data-type": "link",
                  },
                }),
                _c("c-button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover blur",
                        content: "Удалить",
                        placement: "top",
                      },
                      expression:
                        "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                      modifiers: { html: true },
                    },
                  ],
                  staticClass: "file-preview__remove",
                  attrs: { disabled: true, size: "iconic", icon: "trash" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("file-loader", {
        ref: "loader",
        attrs: {
          links: _vm.links,
          format: "images,pdf,docs",
          actions: "loadFiles,preview",
          limit: _vm.field.maxFiles || 10,
          disabled: _vm.preview,
        },
        on: { changeLinks: _vm.updateLinks },
        model: {
          value: _vm.files,
          callback: function ($$v) {
            _vm.files = $$v
          },
          expression: "files",
        },
      }),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }